module.exports = __webpack_public_path__ + "img/443aa48.jpg";